import React, { useState, useEffect, useRef } from 'react';
import './journalist.css';
import { Icon } from '../../../components/icon';
import classNames from 'classnames';
import { selectRandomArrayEntry } from '../../../helpers/active-game';
import { Timer } from '../../../components/timer';

const Journalist = props => {
    const {
        index,
        journalistIsActive,
        subjects,
        activeSubject,
        noTimer,
        sit,
        stand,
        makeAngry,
        makeHappy,
        satisfyJournalist,
    } = props;

    const timerRef = useRef(null);
    const clickRef = useRef(null);
    const [subject, setSubject] = useState(null);
    const [clicks, setClicks] = useState(0);
    const [timeWaiting, setTimeWaiting] = useState(0);

    const journalistButtonClasses = classNames({
        journalist__question: true,
        'journalist__question--hidden': !journalistIsActive,
    });

    useEffect(() => {
        if (journalistIsActive) {
            setSubject(selectRandomArrayEntry(subjects));
            stand();
            if (noTimer === false) {
                timerRef.current = setInterval(() => {
                    setTimeWaiting(timeWaiting => timeWaiting + 1);
                }, 1000);
                clickRef.current = setInterval(() => {
                    setClicks(clicks => Math.max(clicks - 1, 0));
                }, 4000);
                return () => {
                    clearInterval(timerRef.current);
                    clearInterval(clickRef.current);
                };
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [journalistIsActive]);

    useEffect(() => {
        if (timeWaiting === 10) {
            makeAngry();
        } else if (timeWaiting === 20) {
            clearInterval(timerRef.current);
        }
    }, [makeAngry, timeWaiting]);

    const answerQuestion = () => {
        if (noTimer === true) {
            if (clicks === 5) {
                sit();
                setClicks(0);
                setSubject(null);
                satisfyJournalist();
            } else {
                setClicks(clicks + 1);
            }
        }
        if (timeWaiting === 20) {
            setTimeWaiting(16);
            timerRef.current = setInterval(() => {
                setTimeWaiting(timeWaiting => timeWaiting + 1);
            }, 1000);
            setClicks(clicks + 1);
        } else if (timeWaiting < 10 && timeWaiting > 5) {
            makeHappy();
            setTimeWaiting(timeWaiting - 4);
            setClicks(clicks + 1);
        } else if (clicks < timeWaiting / 4) {
            setTimeWaiting(timeWaiting - 4);
            setClicks(clicks + 1);
        } else {
            sit();
            setTimeWaiting(0);
            setClicks(0);
            setSubject(null);
            clearInterval(timerRef.current);
            satisfyJournalist();
        }
    };

    useEffect(() => {
        return () => {
            clearInterval(timerRef.current);
            clearInterval(timerRef.current);
        };
    }, []);

    return (
        <div
            className={`journalist journalist-${index}`}
            aria-label={`journalist-${index}`}
            aria-hidden={!journalistIsActive || subject !== activeSubject}
        >
            {journalistIsActive && noTimer === false && (
                <div className="journalist__timer">
                    <Timer timeElapsed={timeWaiting} maxTime={20} countUp />
                </div>
            )}
            <button
                className={journalistButtonClasses}
                disabled={!journalistIsActive || subject !== activeSubject}
                onClick={() => answerQuestion()}
            >
                {subject && (
                    <div className="journalist__question-bubble">
                        <Icon
                            iconName={subject}
                            size="small"
                            colorScheme="dark"
                            type="png"
                            pressIcon
                        />
                    </div>
                )}
            </button>
            <button
                className="journalist__button"
                disabled={!journalistIsActive || subject !== activeSubject}
                onClick={() => answerQuestion()}
                aria-label={`journalist-${index}`}
            />
        </div>
    );
};

export { Journalist };
